

















import {Vue, Component} from 'vue-property-decorator';
import {modes} from '@/utils/constants';

@Component
export default class Home extends Vue {
    roles = modes;
}
